import { useEffect, useState } from 'react';
import { getSpaceById, getSpaces} from '../services/coworkerApiCalls/Space/Space';
import { Space } from '../services/coworkerApiCalls/Space/SpacesTypes';
import { spaceResponseToSpace, spaceResponsesToSpaces } from '../services/helpers/SpaceMapper';
import 'react-toastify/dist/ReactToastify.css';
import { ID_SPACE } from '../constant';
import { useOktaAuth } from '@okta/okta-react';


function useDataApi() {
    const [spaces, setSpaces] = useState<Space>();
    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {
            const spacesTemporary = await getSpaceById(token, ID_SPACE);
            const spaceResult = spaceResponseToSpace(spacesTemporary);
            setSpaces(spaceResult);
        };
        void getUsers();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Or [] if effect doesn't need props or state


    return spaces;
}


function useDataSpacesApi() {
    const [spaces, setSpaces] = useState<Space[]>();
    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getAllSpaces = async () => {
            const spacesTemporary = await getSpaces(token);
            const spaceResult = spaceResponsesToSpaces(spacesTemporary);
            setSpaces(spaceResult);
        };
        void getAllSpaces();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Or [] if effect doesn't need props or state


    return spaces;
}
export { useDataApi, useDataSpacesApi }